export default class HorseGender {
  constructor () {
    this.setInitialValue()
  }

  setInitialValue () {
    this.horse_sex = {
      translations: [
        { id: null, name: '', lang: 'ar' },
        { id: null, name: '', lang: 'en' }
      ]
    }
  }

  fillData (data) {
    if (data) {
      const itemAr = data.translations?.find(o => o.lang === 'ar')
      const itemEn = data.translations?.find(o => o.lang === 'en')

      this.horse_sex.translations[0].id = itemAr ? itemAr.id : null
      this.horse_sex.translations[0].name = itemAr ? itemAr.name : ''
      this.horse_sex.translations[1].id = itemEn ? itemEn.id : null
      this.horse_sex.translations[1].name = itemEn ? itemEn.name : ''
    } else {
      this.setInitialValue()
    }
  }
}
